var _props, _props2, _props3, _props4, _props5, _props6, _props7, _props8, _props9, _props10, _props11, _props12, _props13, _props14, _props15, _props16, _props17, _props18;

import { TAG_TYPES } from '../../types/TagTypes';
import { IDENTIFIERS } from '../../types/Identifiers';
import PROPS from '../../types/Props';
import { IDs } from './adapter-events-page';
/**
 Here you can find more details about the implementation
 https://docs.google.com/document/d/1n-QE6LXncd_wqz9eQKufxMWnalE-WYxEzdrZ7rixF2A/edit#heading=h.8n2lir49tnp7
*/

export var EVENTS_PAGE = {
  tags: [{
    type: TAG_TYPES.TITLE,
    children: "{{event.name}} | {{site.name}}"
  }, {
    type: TAG_TYPES.META,
    props: (_props = {}, _props[PROPS.NAME] = 'description', _props[PROPS.CONTENT] = "{{event.seo.description}}", _props)
  }, {
    type: TAG_TYPES.META,
    props: (_props2 = {}, _props2[PROPS.NAME] = 'robots', _props2[PROPS.CONTENT] = 'index', _props2)
  }, {
    type: TAG_TYPES.META,
    props: (_props3 = {}, _props3[PROPS.PROPERTY] = 'og:title', _props3[PROPS.CONTENT] = "{{@" + IDENTIFIERS.TITLE + "}}", _props3)
  }, {
    type: TAG_TYPES.META,
    props: (_props4 = {}, _props4[PROPS.PROPERTY] = 'og:description', _props4[PROPS.CONTENT] = "{{@" + IDENTIFIERS.DESCRIPTION + "}}", _props4)
  }, {
    type: TAG_TYPES.META,
    props: (_props5 = {}, _props5[PROPS.PROPERTY] = 'og:image', _props5[PROPS.CONTENT] = "{{event.image.id}}", _props5)
  }, {
    type: TAG_TYPES.META,
    props: (_props6 = {}, _props6[PROPS.PROPERTY] = 'og:image:width', _props6[PROPS.CONTENT] = "{{event.image.width}}", _props6)
  }, {
    type: TAG_TYPES.META,
    props: (_props7 = {}, _props7[PROPS.PROPERTY] = 'og:image:height', _props7[PROPS.CONTENT] = "{{event.image.height}}", _props7)
  }, {
    type: TAG_TYPES.META,
    props: (_props8 = {}, _props8[PROPS.PROPERTY] = 'og:site_name', _props8[PROPS.CONTENT] = '{{site.name}}', _props8)
  }, {
    type: TAG_TYPES.META,
    props: (_props9 = {}, _props9[PROPS.PROPERTY] = 'og:type', _props9[PROPS.CONTENT] = 'website', _props9)
  }, {
    type: TAG_TYPES.META,
    props: (_props10 = {}, _props10[PROPS.PROPERTY] = 'og:url', _props10[PROPS.CONTENT] = "{{event.url}}", _props10)
  }, {
    type: TAG_TYPES.META,
    props: (_props11 = {}, _props11[PROPS.PROPERTY] = 'twitter:title', _props11[PROPS.CONTENT] = "{{@" + IDENTIFIERS.TITLE + "}}", _props11)
  }, {
    type: TAG_TYPES.META,
    props: (_props12 = {}, _props12[PROPS.PROPERTY] = 'twitter:description', _props12[PROPS.CONTENT] = "{{@" + IDENTIFIERS.DESCRIPTION + "}}", _props12)
  }, {
    type: TAG_TYPES.META,
    props: (_props13 = {}, _props13[PROPS.PROPERTY] = 'twitter:image', _props13[PROPS.CONTENT] = "{{@" + IDENTIFIERS.OG_IMAGE + "}}", _props13)
  }, {
    type: TAG_TYPES.META,
    props: (_props14 = {}, _props14[PROPS.PROPERTY] = 'twitter:site', _props14[PROPS.CONTENT] = "{{site.name}}", _props14)
  }, {
    type: TAG_TYPES.META,
    props: (_props15 = {}, _props15[PROPS.NAME] = 'twitter:card', _props15[PROPS.CONTENT] = "summary_large_image", _props15)
  }, {
    type: TAG_TYPES.META,
    props: (_props16 = {}, _props16[PROPS.NAME] = 'twitter:card', _props16[PROPS.CONTENT] = "summary", _props16)
  }, {
    type: TAG_TYPES.LINK,
    props: (_props17 = {}, _props17[PROPS.REL] = 'canonical', _props17[PROPS.CONTENT] = "{{event.url}}", _props17)
  }, {
    type: TAG_TYPES.SCRIPT,
    props: (_props18 = {}, _props18[PROPS.TYPE] = 'application/ld+json', _props18),
    disabled: "{{event.structured-data.schema}}",
    children: "{{event.structured-data.render}}"
  }]
};